import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Form, Input, Menu } from "antd"
import { DownOutlined } from "@ant-design/icons"

import { useStore } from "../contexts/FireStoreContext"
import { useAuth } from "../contexts/AuthContext"

const PageLimitDropDown = () => {
  const limits = [
    // { limit: 1 },
    { limit: 10 },
    { limit: 20 },
    { limit: 50 },
    { limit: 100 }
  ]
  const { user, dispatch } = useAuth()
  const { updateDocumentField } = useStore()
  const [limit, setLimit] = useState(user.limit)

  useEffect(() => {
    setLimit(user.limit)
  }, [user.limit])

  // console.log(user)
  const saveLimit = () => {
    updateDocumentField("users", "limit", limit, user.uid, "Page Preference updated")
      .then(docSnap => {
        dispatch({
          type: "updateField",
          field: {
            limit: limit
          },
          status: "idle"
        })
        // console.log("results", results)
      })
      .catch(error => {
        console.log(error)
      })
  }

  const menu = (
    <Menu>
      {limits.map(l => (
        <Menu.Item key={l.limit}>
          <Button type="text" onClick={() => setLimit(l.limit)}>Views per page {l.limit}</Button>
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <Input.Group>
      <Form.Item noStyle>
        <Dropdown overlay={menu} trigger={['click']}>
          <Button className="border-primary">
            Views per page {limit} <DownOutlined />
          </Button>
        </Dropdown>
      </Form.Item>
      <Form.Item noStyle>
        <Button type="primary" onClick={saveLimit}>
          Save
        </Button>
      </Form.Item>
    </Input.Group>
  )
}

export default PageLimitDropDown
